'use strict';

// this should be the entry point to your library
// module.exports = {
//   demo: require('./demo').default
// };

module.exports = require('./main');